// The <- button to be displayed in title bars.
import React from 'react';

export default class ButtonBack extends React.PureComponent {
  render() {
    const icon = this.props.icon || 'arrow_back';
    return (
      <a
        href="#"
        onClick={e => {
          e.preventDefault();
          this.props.onBack();
        }}
      >
        <i className="material-icons">{icon}</i>
      </a>
    );
  }
}
